/* eslint-disable no-shadow */
export enum AlertMessages {
  networkStatusMessage = 'networkStatusMessage',
  technicalErrorMessage = 'technicalErrorMessage',
  alertsErrorMessage = 'alertsErrorMessage',
  customerRestrictedOGMessage = 'customerRestrictedOGMessage',
  technicalErrorMessageOrdering = 'technicalErrorMessageOrdering',
}
